import type { TImageSize } from '~/types/common';

export const filterImages = (
  images: TImageSize[],
  width: number[],
  _height: number[],
): TImageSize[] => {
  const imagesSort: TImageSize[] = [...images].sort(
    (a: TImageSize, b: TImageSize) => a.width - b.width,
  );
  const imagesSortLast: TImageSize = imagesSort.slice(-1)[0];

  return width
    .sort((a, b) => a - b)
    .map((widthItem: number) => {
      const image: TImageSize | undefined = imagesSort.find(
        (image: TImageSize) => image.width >= widthItem,
      );

      return image || imagesSortLast;
    });
};
